export const matomoState = {
    ready: false,
    queue: [] as ((tracker: any) => void)[]
}   